import * as types from './mutation-types'
// import { defaultStore } from '@/library/firebase'
import * as _ from 'lodash'
import CommonCodeApi from '@/api/commonCodeApi'
import Vue from 'vue'

// 공용으로 사용할 저장소
const state = {
  commonCode: {
    speciality: {},
    city: {}
  }
}

// 데이터 읽기만 수행
const getters = {
  speciality: state => state.commonCode.speciality,
  city: state => state.commonCode.city
}

// 테이터 가져오는 역할
const actions = {
  async [types.GET_COMMONCODE_SPECIALITY]({ commit }) {
    commit('resetSpeciality')
    await new CommonCodeApi().getCategory('speciality').then(result => {
      if (result.length === 0) {
        commit(types.GET_COMMONCODE_SPECIALITY, { id: 0, title: 'Empty' })
      } else {
        _.filter(result, value => {
          commit(types.GET_COMMONCODE_SPECIALITY, {
            id: value.id,
            title: value.codeName
          })
        })
      }
    })
  },
  async [types.GET_COMMONCODE_CITY]({ commit }) {
    commit('resetCity')
    await new CommonCodeApi().getCategory('city').then(result => {
      if (result.length === 0) {
        commit(types.GET_COMMONCODE_CITY, { id: 0, title: 'Empty' })
      } else {
        _.filter(result, value => {
          commit(types.GET_COMMONCODE_CITY, {
            id: value.id,
            title: value.codeName
          })
        })
      }
      // 데이터 변형은 여기서 해준다.
    })
  }
}
// 데이터 변형에 대한 부분
const mutations = {
  [types.GET_COMMONCODE_SPECIALITY](state, result) {
    // state.commonCode.speciality[result.id] = {id: result.id, title: result.title.toUpperCase()}
    Vue.set(state.commonCode.speciality, result.id, {
      id: result.id,
      title: result.title.toUpperCase()
    })
  },
  [types.GET_COMMONCODE_CITY](state, result) {
    // state.commonCode.city[result.id] = {id: result.id, title: result.title.toUpperCase()}
    Vue.set(state.commonCode.city, result.id, {
      id: result.id,
      title: result.title.toUpperCase()
    })
  },
  resetSpeciality(state) {
    Vue.set(state.commonCode, 'speciality', {})
  },
  resetCity(state) {
    Vue.set(state.commonCode, 'city', {})
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
